import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    buscarDistribuidoras: ["payload"],
    buscarDistribuidorasSucesso: ["payload"],
});
const INIT_STATE = {
    listaDistribuidoras: {},
};

const buscarDistribuidorasSucesso = (state = INIT_STATE, action) => ({
    ...state,
    listaDistribuidoras: action.payload,
});

export default createReducer(INIT_STATE, {
    [Types.BUSCAR_DISTRIBUIDORAS_SUCESSO]: buscarDistribuidorasSucesso,
});
